@if (loading) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
} @else {
  <div class="row">
    <div [class.col-md-8]="!mediaExpanded" [class.col-md-6]="mediaExpanded">
      <div class="d-flex align-items-center gap-3 mb-4">
        @if (selectedCountry?.img) {
          <img
            class="country-flag"
            [src]="selectedCountry.img"
            [alt]="selectedCountry.countryName"
          />
        }

        <div>
          <h2 class="mb-0">
            {{ selectedCountry?.countryName || currentCountry }}
          </h2>

          <small class="text-muted">
            {{ translations.patient_retrieve }}
          </small>
        </div>
      </div>

      <form #countryForm="ngForm" (ngSubmit)="search()">
        @if (isSpain()) {
          <div
            class="identifier-option mb-4"
            [class.identifier-option-disabled]="hasNationalIdentifier()"
          >
            <h5 class="mb-1">
              {{ translations.regional_id }}
            </h5>

            <small class="text-muted d-block mb-3">
              {{ translations.regional_search }}
            </small>

            @for (identifier of identifiers.slice(0, 2); track $index) {
              <div class="mb-3">
                <label class="form-label fw-bold">
                  {{ identifier.contextualDescription }}
                </label>

                <input
                  type="text"
                  class="form-control"
                  name="identifier_{{ $index }}"
                  [(ngModel)]="identifier.extension_value"
                  [disabled]="hasNationalIdentifier()"
                />
              </div>
            }
          </div>

          <div class="identifier-separator">
            <span>{{ translations.or }}</span>
          </div>

          <div
            class="identifier-option mb-4"
            [class.identifier-option-disabled]="hasRegionalIdentifier()"
          >
            <h5 class="mb-1">
              {{ translations.national_id }}
            </h5>

            <small class="text-muted d-block mb-3">
              {{ translations.national_search }}
            </small>

            @if (identifiers[2]) {
              <div class="mb-3">
                <label class="form-label fw-bold">
                  {{ identifiers[2].contextualDescription }}
                </label>

                <input
                  type="text"
                  class="form-control"
                  name="identifier_2"
                  [(ngModel)]="identifiers[2].extension_value"
                  [disabled]="hasRegionalIdentifier()"
                />
              </div>
            }
          </div>
        } @else {
          @for (identifier of identifiers; track $index) {
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold">
                {{ identifier.contextualDescription }}
              </label>

              <input
                type="text"
                class="form-control"
                name="identifier_{{ $index }}"
                [(ngModel)]="identifier.extension_value"
              />
            </div>

            @if (identifier.birthDate) {
              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">
                  {{ identifier.birthDate }}
                </label>

                <input
                  type="date"
                  class="form-control"
                  name="birthDate_{{ $index }}"
                  [(ngModel)]="identifier.extension_value_date"
                />
              </div>
            }
          }
        }

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!isFormValid() || searching"
        >
          {{ translations.search }}
        </button>

        @if (searching) {
          <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
            <p-progress-spinner ariaLabel="loading" />
          </div>
        }
      </form>
    </div>

    <div [class.col-md-4]="!mediaExpanded" [class.col-md-6]="mediaExpanded">
      @if (media) {
        <div class="media-container">
          <h5 class="mb-3">
            {{ media.description }}
          </h5>

          <img
            class="country-media"
            [class.expanded]="mediaExpanded"
            [src]="getMediaSrc()"
            [alt]="media.description"
            (click)="toggleMediaExpand()"
          />
        </div>
      }
    </div>
  </div>
}
